import { render, staticRenderFns } from "./PrivateMessageView.vue?vue&type=template&id=762028cf&"
import script from "./PrivateMessageView.vue?vue&type=script&lang=js&"
export * from "./PrivateMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports